export default __webpack_public_path__ + "static/media/721.fcb6fdb8.gif";